/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-mixed-operators */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable max-len */
/* eslint-disable no-debugger */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
/* eslint-disable eqeqeq */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, {
    useEffect, useState, useRef, useContext,
} from 'react';

import {
    useLocation,
    Link,
} from 'react-router-dom';
import { ThreeDots } from 'react-loader-spinner';
import Toggle from 'react-toggle';
import { toast } from 'react-toastify';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import { motion } from 'framer-motion';
import HeaderContext from '../Components/Context/HeaderContext';
import UserListingHeaderSkeleton from '../Components/Skeletons/UserListingHeaderSkeleton';
import { AccessPrevilegesFunction } from '../constants/GlobalAccessFunction';

function TableHeader({
    logout, setsearchValue, filter, setfilter, exportClick,
    exportSelected,
    setexportClick,
    setexportSelected,
    setisEditId,
    list,
    setCurrentPage,
    searchValue,
    NoAddButton,
    directOrder,
    setDirectOrderPopup,
    pendingToggle,
    pending,
    setPending,
    previlegeassigned,
}) {
    const [name, setName] = useState('');
    const { HardRefresh, setHardRefresh } = useContext(HeaderContext);
    const [exportIndicatorLoading, setExportIndicatorLoading] = useState(false);
    const ref = useRef();
    const variants = {
        open: { opacity: 1, x: 0 },
        closed: { opacity: 0, x: '-25%' },
    };

    const handleLogout = () => {
        logout();
    };
    let title;
    const handleClickOutside = (event) => {
        if (exportClick) {
            setexportClick(false);
        }
    };
    const { pathname } = useLocation();
    switch (pathname) {
        case '/': title = 'Manage Internal Users';
            break;
        case '/manage-internal-users': title = 'Manage Internal Users ';
            break;

        default: title = '';
    }
    const handlePath = () => {
        let path = '';
        switch (pathname) {
            case '/manage-internal-users':
                path = 'Internal Users';
                break;
            case '/':
                path = 'Internal Users';
                break;
            case '/manage-offers':
                path = 'Trade & Commercial Policy/Offers';
                break;
            case '/manage-freight-policy':
                path = 'Freight Policy (DAP)';
                break;
            case '/manage-pending-approvals':
                path = 'Manage Pending Approvals';
                break;
            case '/ador-cash-management':
                path = 'Ador Cash Management';
                break;
            case '/manage-orders':
                path = 'Manage Orders';
                break;
            case '/cancelled-orders':
                path = 'Cancelled Orders';
                break;
            case '/invoices':
                path = 'Invoices';
                break;
            default: break;
        }
        return path;
    };
    const handlePathUrl = () => {
        let path = '';
        switch (pathname) {
            case '/manage-internal-users':
                path = '/manage-internal-users/create-admin-user';
                break;
            case '/':
                path = '/manage-internal-users/create-admin-user';
                break;
            case '/manage-offers':
                path = '/manage-offers/create-new-offer';
                break;
            case '/manage-freight-policy':
                path = '/manage-freight-policy/create-new-dap';
                break;
            default: break;
        }
        return path;
    };

    const handleExportLoadingIndicator = () => {
        setExportIndicatorLoading(true);
        setTimeout(() => {
            setExportIndicatorLoading(false);
        }, 2000);
    };
    return (
        <>
            {(pathname === '/manage-internal-users' || pathname === '/' || pathname === '/manage-offers' || pathname === '/manage-freight-policy' || pathname === '/manage-pending-approvals' || pathname === '/distributors' || pathname === '/manage-orders' || pathname === '/ador-cash-management' || pathname === '/cancelled-orders' || pathname === '/invoices') && !HardRefresh ? (
                <motion.div
                    animate={{ opacity: 1, x: 0 }}
                    initial={{ opacity: 0, x: -10 }}
                    exit={{ opacity: 0, x: -10 }}
                    transition={{ duration: 0.15 }}
                    className="flex justify-between w-full sticky top-[93px] pb-[18px] bg-[#FFFFFF] pt-[25px]"
                    style={{ paddingBottom: '18px', zIndex: '99' }}
                    onClick={() => handleClickOutside()}
                >
                    <h5 className="text-xs4 font-semibold text-[#555259]">{handlePath()}</h5>
                    <div className="flex" ref={ref}>
                        {pendingToggle && (
                            <div className="relative mr-4">
                                <Toggle
                                    id="pending"
                                    checked={pending}
                                    icons={false}
                                    onChange={() => setPending(!pending)}
                                />
                                <label htmlFor="pending"> Waiting for approval </label>
                            </div>
                        )}
                        <div className="relative">
                            <label htmlFor="search" />
                            <input
                                type="text"
                                name="search"
                                id="search"
                                data-testid="search"
                                autoComplete="off"
                                value={searchValue || ''}
                                onChange={(e) => {
                                    setsearchValue((e.target.value));
                                    setCurrentPage(1);
                                }}
                                className="w-[235px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px]"
                                placeholder="Search"
                            />
                            <img src="images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px]" />
                        </div>
                        <div className="pl-2">
                            <button
                                onClick={() => setfilter(!filter)}
                                type="button"
                                className="h-[35px] text-xs2 font-semibold text-[#555259] px-6 border border-[#555259] rounded-lg"
                                data-bs-toggle="modal"
                                data-bs-target="#filtermodal"
                                data-testid="filter-btn"
                            >
                                Filter
                            </button>
                        </div>
                        <div className="pl-2">
                            <button
                                onClick={() => {
                                    setisEditId('');
                                    setexportClick(!exportClick);
                                }}
                                disabled={list && list.length === 0}
                                type="button"
                                id="exportDropdown"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                data-testid="export-btn"
                                className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] px-9 border border-[#555259] rounded-lg"
                            >
                                {exportIndicatorLoading ? <ThreeDots width={30} height={24} /> : 'Export'}
                            </button>
                            <motion.ul
                                initial={false}
                                style={{ zIndex: '99' }}
                                animate={exportClick ? 'open' : 'closed'}
                                className={`dropdown-menu min-w-[111px] absolute 
             ${exportClick ? 'show' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2`}
                            >
                                <li
                                    className="px-5 pb-1.5 pt-5"
                                >
                                    <a data-testid="csv-btn" className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" href="javascript:void(0)" onClick={() => { setexportSelected('export-csv'); handleExportLoadingIndicator(); }}>CSV</a>
                                </li>
                                <li className="px-5 py-1.5">
                                    <a data-testid="pdf-btn" className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" href="javascript:void(0)" onClick={() => { setexportSelected(`${pathname === '/manage-orders' ? 'pdf-converter/orders' : pathname === '/manage-offers' ? 'offers/html-to-pdf' : 'admin-user/html-to-pdf'}`); handleExportLoadingIndicator(); }}>PDF</a>
                                </li>
                                <li className="px-5 pt-1.5 pb-5">
                                    <a data-testid="excel-btn" className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" href="javascript:void(0)" onClick={() => { setexportSelected('export-excel'); handleExportLoadingIndicator(); }}>Excel</a>
                                </li>
                            </motion.ul>
                        </div>
                        {(NoAddButton === undefined && previlegeassigned === true)
                            && (
                                <div className="pl-2">
                                    <button type="button" className="h-[35px] text-xs2 font-semibold text-[#FFFFFF] px-7 bg-[#555259] rounded-lg">
                                        <Link to={handlePathUrl()}>
                                            Add New
                                        </Link>
                                    </button>
                                </div>
                            )}
                        {(directOrder === true && previlegeassigned === true)
                            && (
                                <div className="pl-2">
                                    <button
                                        type="button"
                                        className="h-[35px] text-xs2 font-semibold text-[#FFFFFF] px-7 bg-[#555259] rounded-lg"
                                        onClick={() => setDirectOrderPopup(true)}
                                    >
                                        Create Direct Order
                                    </button>
                                </div>
                            )}
                    </div>

                </motion.div>
            ) : <UserListingHeaderSkeleton />}
            <>

            </>
        </>

    );
}

export default TableHeader;
